"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));
var Styled = _interopRequireWildcard(require("./styles/IconMinutesSms.style"));
var _ruleSet = require("../../ruleSet");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var IconMinutesSms = function IconMinutesSms(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
    _ref$isResponsive = _ref.isResponsive,
    isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    state = _ref.state,
    numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.285 4.516h-4.57m4.57 1.968h-4.57m6.738-2.453V2.598H20",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 2.598h-6.34c-.613 0-1.113.496-1.113 1.113v3.707a1.111 1.111 0 0 0 1.113 1.113h4.152l2.157 2.031v-2.03h.375c.293 0 .578-.118.785-.325.21-.21.328-.492.324-.789V4.031M7.95 5.07l1.183 3.301.027.086a.374.374 0 0 1-.125.426 4.34 4.34 0 0 1-1.27.664 7.656 7.656 0 0 1-1.68.328.364.364 0 0 0-.308.473 12.259 12.259 0 0 0 3.02 4.968 12.37 12.37 0 0 0 5 3.008.365.365 0 0 0 .457-.242.182.182 0 0 0 .012-.066c.05-.567.164-1.13.336-1.668.152-.457.378-.883.668-1.262a.373.373 0 0 1 .43-.125l.085.027 3.317 1.18c.789.277 1.816.57 2.367.84.008 0 0 .015 0 .023a3.447 3.447 0 0 1-.145 1.258c-.375 1.219-1.387 2.527-2.582 2.875-3.015.898-6.191-.023-9-1.43a12.146 12.146 0 0 1-5.383-5.359c-1.418-2.79-2.343-5.95-1.441-8.95C3.273 4.239 4.59 3.23 5.812 2.86l.95-.25c.18-.05.363.051.426.227Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }))), numberBadge ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })) : null);
};
IconMinutesSms.displayName = "IconMinutesSms";
var _default = IconMinutesSms;
exports["default"] = _default;